import { GAeventSubmit } from '@app/utils/GAevents';
import { pushFileDownload } from '@app/components/TagManager';

export const eventToLink = (nameFile: string) => {
	GAeventSubmit('Files', 'Download', nameFile);
	pushFileDownload(nameFile);
};
